var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.35 0H4.31A1.2 1.2 0 003.1 1.211v.968H1.21A1.2 1.2 0 000 3.39v10.365a1.2 1.2 0 001.21 1.211h10.366a1.2 1.2 0 001.21-1.211v-.968h1.89a1.2 1.2 0 001.21-1.212V3.342L12.351 0zM5.183 11.333a.521.521 0 01-.338.145.522.522 0 01-.34-.145.468.468 0 010-.678L7.75 7.41H5.813a.485.485 0 010-.968h3.1c.048 0 .145 0 .193.048a.586.586 0 01.242.243c.049.048.049.145.049.193v3.1c0 .29-.243.484-.485.484s-.484-.242-.484-.484V8.089l-3.246 3.244zM12.544.436l2.858 2.712h-1.84a1.023 1.023 0 01-1.018-1.017V.436zm-.532 13.319a.382.382 0 01-.388.387H1.211a.382.382 0 01-.388-.387V3.39c0-.242.194-.387.388-.387H3.1v8.573a1.2 1.2 0 001.21 1.21h7.702v.969z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default ForwardRef;